/**
 * Placeholder function.
 *
 * @returns Undefined
 */
export const noop = (): undefined => void 0;
